import { render, staticRenderFns } from "./ResellerForm.vue?vue&type=template&id=1d0af485&scoped=true"
import script from "./ResellerForm.vue?vue&type=script&lang=js"
export * from "./ResellerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0af485",
  null
  
)

export default component.exports